import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { DarkThemeProvider } from './DarkThemeContext';

ReactDOM.render(
  <React.StrictMode>
    <DarkThemeProvider>
      <App />
    </DarkThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);


